import type { ViewDevice } from '../types';

export const calculateViewDevice = (): ViewDevice => {
  if (window.matchMedia('(min-width: 769px)').matches) {
    return 'DESKTOP';
  } else {
    return 'MOBILE';
  }
};
